import { Button as CollectrButton } from "./ui/button";
import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };

type State = { hasError: boolean };

/**
 * Catches render errors below this boundary so a single subtree failure does not blank the whole SPA.
 * Keeps messaging operator-safe (no stack traces in UI).
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) {
      console.error("[AppErrorBoundary]", error, info.componentStack);
    } else {
      console.error("[AppErrorBoundary]", error.name);
    }
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  private handleRetry = (): void => {
    this.setState({ hasError: false });
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 py-12 text-foreground">
          <div className="w-full max-w-md rounded-lg border border-border bg-card p-8 shadow-sm">
            <h1 className="text-lg font-semibold tracking-tight text-foreground">Er ging iets mis</h1>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              De operatorconsole kon dit scherm niet laden. Dit komt meestal door een tijdelijk probleem. Ververs de pagina
              of ga een stap terug en probeer opnieuw.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <CollectrButton
                type="button"
                onClick={this.handleReload}

              >
                Pagina verversen
              </CollectrButton>
              <CollectrButton
                type="button"
                onClick={this.handleRetry}
                variant="outline"
              >
                Opnieuw proberen
              </CollectrButton>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
